import { VIEWPORT_TOOLSET_IDS } from "@/viewport-tools/core/contracts";
import {
  type MeasurementToolsetRailController,
  type ViewportToolsetRailController,
  type ViewportToolsetRailPlugin,
} from "@/viewport-tools/rail/types";
import { renderMeasurementToolsetRail } from "@/viewport-tools/measurement/rail-renderer";

function isMeasurementToolsetRailController(
  controller: ViewportToolsetRailController
): controller is MeasurementToolsetRailController {
  return controller.toolsetId === VIEWPORT_TOOLSET_IDS.measurement;
}

export const MEASUREMENT_TOOLSET_RAIL_PLUGIN: ViewportToolsetRailPlugin<MeasurementToolsetRailController> =
  {
    id: VIEWPORT_TOOLSET_IDS.measurement,
    isController: isMeasurementToolsetRailController,
    render: renderMeasurementToolsetRail,
  };
